import { HttpHandler } from '../../api/HttpHandler';
import { environment } from '../../enviroments';

export const getUsersSavedCards = async (userID: string) => {
  const PAYMENTS_URL = environment.PAYMENTS_URL;

  const paymentMethodsList = await HttpHandler({
    method: 'GET',
    url: `${PAYMENTS_URL}/customer/${userID}/payment-methods`,
  });

  return paymentMethodsList.data.data;
};
